@for (menu of menuItems; track menu; let first = $first) {
  <div class="menu-item">
    @if (!menu.hidden && menu.routerLink && !menu.hasSubMenu) {
      <a mat-button [routerLink]="[menu.routerLink]" [queryParams]="menu.queryParams" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}" (click)="onClick(menu)" [id]="'menu-item-'+menu.id">
        <span>{{menu.title}}</span>
      </a>
    }
    @if (!menu.hidden && menu.href && !menu.hasSubMenu) {
      <a mat-button [attr.href]="menu.href || ''" [attr.target]="menu.target || ''" (click)="onClick(menu)" [id]="'menu-item-'+menu.id">
        <span>{{menu.title}}</span>
      </a>
    }
    @if (!menu.hidden && menu.hasSubMenu) {
      <button mat-button type="button" (click)="onClick(menu)" [class.expanded]="expandedMenuId() === menu.id" [attr.aria-expanded]="expandedMenuId() === menu.id">
        <span>{{menu.title}}</span>
        <mat-icon iconPositionEnd class="menu-expand-icon transition-2">arrow_drop_down</mat-icon>
      </button>
      <!-- render only while expanded: iOS Safari does not repaint a max-height transition inside the sidenav -->
      @if (expandedMenuId() === menu.id) {
        <div class="sub-menu" animate.enter="sub-menu-enter">
          <app-vertical-menu [menuParentId]="menu.id" (routerLinkSelected)="routerLinkSelected.emit(menu.routerLink)"></app-vertical-menu>
        </div>
      }
    }
  </div>
  <!-- quick links go right below the first item (Properties) -->
  @if (first) {
    <ng-container [ngTemplateOutlet]="quickLinks"></ng-container>
  }
}

<!-- quick links shown as icons in the toolbar on wide screens (hidden there together with the horizontal menu) -->
<ng-template #quickLinks>
  @if (menuParentId() === 0 && (authenticated | async) == true && isSuperAdmin) {
    <div class="menu-item">
      <a mat-button routerLink="/account/favorites" routerLinkActive="active-link" (click)="routerLinkSelected.emit(undefined)">
        @let favCount = (favoriteProperties | async)?.length ?? 0;
        <span>Favorites</span>
        @if (favCount > 0) { <span class="quick-link-count">{{favCount}}</span> }
      </a>
    </div>
    @if (compareVisible) {
      <div class="menu-item">
        <a mat-button routerLink="/account/compare" routerLinkActive="active-link" (click)="routerLinkSelected.emit(undefined)">
          @let compCount = (comparableProperties | async)?.length ?? 0;
          <span>Compare</span>
          @if (compCount > 0) { <span class="quick-link-count">{{compCount}}</span> }
        </a>
      </div>
    }
  }
</ng-template>
